<!--
 * @Author: qinmengyuan
 * @Date: 2024-08-16 14:50:08
 * @LastEditors: qinmengyuan 2715025514@qq.com
 * @LastEditTime: 2024-08-21 16:49:53
 * @FilePath: \onetab\src\components\ShareLinkPop.vue
-->
<template>
  <RaDialog
    width="400px"
    :model-value="visible"
    :before-close="handleClose"
    :append-to-body="true"
    class="link-modal"
    title="分享链接"
  >
    <div class="container">
      <div class="desc">
        <RaIcon icon="CheckCircle"></RaIcon>链接已生成，分享给好友吧
      </div>
      <RaInput v-model="inputValue" />
    </div>
    <div class="btns">
      <RaButton
        type="neutral"
        status="secondary"
        class="btn"
        @click="emits('close')"
        >取消</RaButton
      >
      <RaButton type="primary" class="btn" status="main" @click="handleCopy"
        >复制链接</RaButton
      >
    </div>
  </RaDialog>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import {
  RaDialog,
  RaInput,
  RaCheckboxGroup,
  RaCheckbox,
  RaMessage,
  RaButton,
} from '@rafter/pc';
import { RaIcon } from '@rafter/icon';
const emits = defineEmits(['close']);
const inputValue = ref('');
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  value: {
    type: String,
    default: '',
  },
});
watch(
  () => props.visible,
  () => {
    if (props.visible) {
      inputValue.value = props.value;
    }
  }
);
const handleCopy = async () => {
  await navigator.clipboard.writeText(inputValue.value);
  RaMessage.success('复制成功');
};
const handleClose = () => {
  emits('close');
};
</script>
<style lang="scss">
.link-modal {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  border-radius: 24px !important;
  min-height: 224px !important;
  @include background_color('base-bg-color-09');
  backdrop-filter: blur(40px);
  .ra-dialog__header {
    padding: 16px 24px !important;
    .ra-dialog__title {
      @include font_color('text-on-surface-primary');
      font-family: 'PingFang SC';
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 150% */
    }
  }
  .ra-dialog__body {
    padding: 0 24px !important;
    display: flex;
    flex-direction: column;
    .container {
      display: flex;
      gap: 12px;
      flex-direction: column;
      flex: 1;
    }
    .desc {
      @include font_color('text-on-surface-primary');
      /* web/cn/heading/heading-01 */
      font-family: 'PingFang SC';
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px; /* 157.143% */
      letter-spacing: 0.5px;
      display: flex;
      align-items: center;
      gap: 8px;
      i {
        font-size: 22px;
        color: rgba(56, 127, 252, 1);
      }
    }
  }
  .btns {
    display: flex;
    padding: 20px 0;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 16px;
    align-self: stretch;
    .btn {
      width: 106px;
    }
  }
}
</style>
